import {
  DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST,
  DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS,
  DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL,

  DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST,
  DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS,
  DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL,

  DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST,
  DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS,
  DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL,

  DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST,
  DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS,
  DRIVER_PARTNER_PAID_COMMISSIONS_FAIL,

  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST,
  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS,
  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL,

  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST,
  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS,
  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL,

  DRIVER_PARTNER_TOP_PERFORMING_REQUEST,
  DRIVER_PARTNER_TOP_PERFORMING_SUCCESS,
  DRIVER_PARTNER_TOP_PERFORMING_FAIL,
} from "../actions/types";

const initialState = {
  loading: false,
  summary: null,
  partnerPerformance: [],
  commissionLiability: null,
  paidCommissions: [],
  suspiciousReferrals: [],
  referredDriverLocations: [],
  topPerformingPartners: [],
  error: null,
};

const driverPartnerAnalyticsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST:
    case DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST:
    case DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST:
    case DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST:
    case DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST:
    case DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST:
    case DRIVER_PARTNER_TOP_PERFORMING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summary: action.payload,
      };

    case DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        partnerPerformance: action.payload,
      };

    case DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        commissionLiability: action.payload,
      };

    case DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        paidCommissions: action.payload,
      };

    case DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS:
      return {
        ...state,
        loading: false,
        suspiciousReferrals: action.payload,
      };

    case DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        referredDriverLocations: action.payload,
      };

    case DRIVER_PARTNER_TOP_PERFORMING_SUCCESS:
      return {
        ...state,
        loading: false,
        topPerformingPartners: action.payload,
      };

    case DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL:
    case DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL:
    case DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL:
    case DRIVER_PARTNER_PAID_COMMISSIONS_FAIL:
    case DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL:
    case DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL:
    case DRIVER_PARTNER_TOP_PERFORMING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default driverPartnerAnalyticsReducer;